import React from 'react';
import Box from '@mui/material/Box';
import DoneIcon from '@mui/icons-material/Done';
import Typography from '@mui/material/Typography';
import useEmotionStyles from '../../hooks/useEmotionStyles';
import { useMediaQueryOrBoolean, } from '../../hooks/useMediaQueryOrBoolean';
var styles = function () { return ({
    point: {
        display: 'flex',
    },
    pointIcon: {},
    pointText: {},
}); };
var helpers = {
    getTypographyVariant: function (size) {
        if (size === 'md') {
            return 'body2';
        }
        return 'body1';
    },
    getItemMB: function (size) {
        if (size === 'md') {
            return 1;
        }
        return 4;
    },
    getIconFontSize: function (size) {
        if (size === 'md') {
            return 'small';
        }
        return 'medium';
    },
};
var List = function (_a) {
    var items = _a.items, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.white, white = _c === void 0 ? false : _c, className = _a.className, _d = _a.isCheckIconVisible, isCheckIconVisible = _d === void 0 ? true : _d;
    var cs = useEmotionStyles(styles);
    var shouldShowCheckIcon = useMediaQueryOrBoolean(isCheckIconVisible, true);
    var itemMB = helpers.getItemMB(size);
    var itemVariant = helpers.getTypographyVariant(size);
    var iconFontSize = helpers.getIconFontSize(size);
    var fontColor = white ? '#FFFFFF' : undefined;
    var iconMarginRight = size === 'md' ? 1 : 2;
    return (React.createElement("div", { className: className }, items.map(function (item) { return (React.createElement(Box, { mb: itemMB, className: cs.point, key: item },
        shouldShowCheckIcon && (React.createElement(Box, { mr: iconMarginRight, className: cs.pointIcon },
            React.createElement(DoneIcon, { color: 'primary', fontSize: iconFontSize }))),
        React.createElement(Typography, { variant: itemVariant, color: fontColor }, item))); })));
};
export default List;
